import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import axios from 'axios';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import CustomerSuggestionBox from '../CommonComp/CustomerSuggestionBox';
import BankSuggestionBox from '../CommonComp/BankSuggestionBox';
import ViewCustomer from "../Master/ViewCustomer"
import AddCustomerModal from "../Master/Add/AddCustomerModal";
import Swal from "sweetalert2";
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import CustomDateInput from '../CommonComp/CustomDateInput';

const ReceivePaymentEdit = () => {
    const [options, setOptions] = useState([]);
    const [bills, setBills] = useState(0);
    const [payingAmount, setPayingAmount] = useState(0);
    const requiresCustomerRef = useRef(null);
    const accessToken = localStorage.getItem('accessToken');
    const [searchValue, setSearchValue] = useState([]);
    const [checkedRows, setCheckedRows] = useState([]);
    const navigate = useNavigate();
    const [deliveryDate, setDeliveryDate] = useState('');
    const [details, setDetails] = useState('');
    const [transactionRef, setTransactionRef] = useState('');
    const [tableRow, setTableRow] = useState([]);
    const [customerInfo, setCustomerInfo] = useState(null); 
    const [bankInfo, setBankInfo] = useState(null);
    const [initialBankId, setInitialBankId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
//For customer modal
const [showModal, setShowModal] = useState(false);
const handleCloseModal = () => setShowModal(false);
const id = useParams();

const handleDateChange = (e) => {
    setDeliveryDate(e.target.value);
};
const handleDetailsChange = (e) => {
    setDetails(e.target.value);
};
const handleTransactionChange = (e) => {
    setTransactionRef(e.target.value);
};

// const handleCustomerChange = (selectedCustomer) => {
//     setCustomerInfo(selectedCustomer); 
//     if(selectedCustomer){
//         getRequiresCustomerList(selectedCustomer.value);
//     }else{
//         setTableRow([]);
//     }
// };

  useEffect(() => {
    axios.get(`${config.api_url}/ws-get-customer-list`)
      .then(response => {
        const customerData = response.data.customer;
        
        // Format the customer data to match the options for the Select dropdown
        const customerOptions = customerData.map(item => ({
          label: item.company_name,
          value: item.id,
        }));

        setOptions(customerOptions);  // Set the options state
      })
      .catch(error => {
        console.error(error);
      });
  }, []); // Empty dependency array means this runs once when the component mounts



const handleBankChange = (selectedBank) => {
    setBankInfo(selectedBank);
};

const getRequiresCustomerList = async (customerId) => {
    setTableRow([]);
    const formData = new FormData();
    formData.append('customer_id', customerId);
    const apiUrl = `${config.api_url}/ws-received-customer-payment`;

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
      },
      body: formData,
  });

      if (!response.ok) 
      {
          throw new Error('Failed to fetch new sales data');
      }
      const data = await response.json();
      const rows = data.data ? data.data : [];
      setTableRow(rows);
  } catch (error) {
      console.error('Error fetching new sales data:', error);
  }


};

    const parseMoney = (v) => {
        if (v === null || v === undefined || v === '') return NaN;
        return parseFloat(String(v).replace(/,/g, '').trim());
    };

    const getMaxPayForRow = (row) => {
        if (row.balanceBase != null && !Number.isNaN(row.balanceBase)) {
            return Math.max(0, Math.round(row.balanceBase * 100) / 100);
        }
        const b = parseMoney(row.balance);
        if (!Number.isNaN(b) && b >= 0) return Math.max(0, Math.round(b * 100) / 100);
        const v = parseMoney(row.value);
        if (!Number.isNaN(v)) return Math.max(0, Math.round(v * 100) / 100);
        return 0;
    };

const calculateTotals = (rows, selectedRows = checkedRows) => {
    const totalPay = Math.round(rows
    .filter((_, idx) => selectedRows.includes(idx))
    .reduce((total, row) => total + (parseFloat(row.pay) || 0), 0) * 100) / 100;
    setPayingAmount(totalPay);

    const totalBill = Math.round(rows
    .filter((_, idx) => selectedRows.includes(idx))
    .reduce((sum, row) => sum + getMaxPayForRow(row), 0) * 100) / 100;

    setBills(totalBill);
};

useEffect(() => {
    axios.get(`${config.api_url}/ws-edit-sales-ledger/${id.id}`) 
    .then(response => {
            if (response.data.success) {
                const rows = Array.isArray(response.data.data) ? response.data.data : [];
                const mappedRows = rows.map((row) => {
                    const bal = parseMoney(row.balance);
                    const balanceAmt = Number.isNaN(bal) ? 0 : bal;
                    const balanceBase = Math.max(0, Math.round(balanceAmt * 100) / 100);
                    return {
                        ...row,
                        pay: '',
                        balanceBase
                    };
                });
                setTableRow(mappedRows);
                setCheckedRows([]);
                setPayingAmount(0);
                const inputData = mappedRows[0] || {};
                if (inputData.details) {
                    setDetails(inputData.details);
                }
                if (inputData.transaction_ref) {
                    setTransactionRef(inputData.transaction_ref);
                }
                if (inputData.bank_id) {
                    setInitialBankId(inputData.bank_id);
                }
                if (mappedRows.length > 0) {
                    setBills(getMaxPayForRow(mappedRows[0]));
                }
            } else {
                setTableRow([]);
            }
        })
    .catch(error => {
        console.error('Error fetching bills:', error);
        setTableRow([]);
    });
}, []);

// const handlePayChange = (index, value) => {
//     const newTableRow = [...tableRow];
//     newTableRow[index].pay = parseFloat(value) || 0;
//     setTableRow(newTableRow);
//     calculateTotals(newTableRow);
// };


const handlePayChange = (index, value) => {
    const newTableRow = [...tableRow];
    const row = { ...newTableRow[index] };
    const maxPay = getMaxPayForRow(row);
    if (value === '' || value === null) {
        row.pay = '';
    } else {
        const num = parseFloat(value);
        if (Number.isNaN(num)) {
            row.pay = '';
        } else if (num < 0) {
            row.pay = 0;
        } else if (num > maxPay + 1e-9) {
            Swal.fire({
                title: 'Error!',
                text: 'Pay amount cannot exceed the remaining balance.',
                icon: 'error',
                timer: 2000,
                showConfirmButton: false,
            });
            row.pay = maxPay;
        } else {
            row.pay = Math.round(num * 100) / 100;
        }
    }
    newTableRow[index] = row;
    setTableRow(newTableRow);
    calculateTotals(newTableRow);
};


const handleCheckboxChange = (index) => {
    setCheckedRows((prevCheckedRows) => {
        const newCheckedRows = prevCheckedRows.includes(index)
        ? prevCheckedRows.filter((rowIndex) => rowIndex !== index) 
        : [...prevCheckedRows, index]; 

        calculateTotals(tableRow, newCheckedRows);
        return newCheckedRows;
    });
};

  const handleCustomerChange = (selectedOption) => {
    const selectedCustomerValue = selectedOption ? selectedOption.value : null;

    if (selectedCustomerValue) {
      // Call API to get data for the selected customer
      axios.get(`${config.api_url}/ws-get-customer-list`)
        .then(response => {
          const customer = response.data.customer;

          setCustomerInfo(customer);
          console.log(customer);

          // Check if customer exists and handle further logic
          if (customer) {
           // alert(customer.company_name);  // Show the customer value
            getRequiresCustomerList(customer.value);  // Call the function with the correct value
          } else {
            setTableRow([]);  // Clear the table rows if no customer data
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  };

const handleSubmit = async (event, action) =>
{
    event.preventDefault();

    if (isSubmitting) {
        return;
    }

    const overPay = tableRow
        .filter((_, idx) => checkedRows.includes(idx))
        .find((row) => (parseFloat(row.pay) || 0) > getMaxPayForRow(row) + 1e-9);
    if (overPay) {
        Swal.fire({
            title: 'Error!',
            text: 'Pay amount cannot exceed the remaining balance for a selected bill.',
            icon: 'error',
            timer: 2000,
            showConfirmButton: false,
        });
        return;
    }

    if (!deliveryDate || deliveryDate === '0000-00-00') {
        Swal.fire({
            title: 'Error!',
            text: 'Please select a date.',
            icon: 'error',
            timer: 2500,
            showConfirmButton: false,
        });
        return;
    }

    const bank = bankInfo?.value ?? initialBankId ?? '';
    if (!bank) {
        Swal.fire({
            title: 'Error!',
            text: 'Please select a bank.',
            icon: 'error',
            timer: 2500,
            showConfirmButton: false,
        });
        return;
    }

    const formData = new FormData();
        // Gather simple fields
        const customer = tableRow?.[0]?.customer_id;
        const dDate = deliveryDate ? deliveryDate : '';
        const detailInfo = details ? details : '';
        const transactionInfo = transactionRef ? transactionRef : '';
        
        formData.append('customer_id', customer);
        formData.append('date', dDate);
        formData.append('bank_id', String(bank));
        formData.append('details', detailInfo);
        formData.append('transaction_ref', transactionInfo);
        formData.append('paying_amount', Math.round(payingAmount * 100) / 100);
        formData.append('balance', Math.round((bills - payingAmount) * 100) / 100);

        const selectedRowsData = tableRow
        .filter((_, idx) => checkedRows.includes(idx))
        .filter((row) => (parseFloat(row.pay) || 0) > 0)
        .map((row) => ({
            sales_id: row.sales_id,
            pay: parseFloat(row.pay) || 0,
        }));

        if (selectedRowsData.length === 0) {
            Swal.fire({
                title: 'Error!',
                text: 'Select at least one bill and enter a pay amount.',
                icon: 'error',
                timer: 2500,
                showConfirmButton: false,
            });
            return;
        }

        formData.append('selected_rows', JSON.stringify(selectedRowsData));
        formData.append('sales_ledger_id', id.id);

        const apiUrl = `${config.api_url}/ws-submit-received-payment`;

        setIsSubmitting(true);
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            // Check if the response was successful
            const data = await response.json();

            if (!response.ok || !data.success) {
                Swal.fire({
                    title: 'Error!',
                    text: data.message || 'Failed to submit payment data',
                    icon: 'error',
                    timer: 3000,
                    showConfirmButton: false,
                });
                return;
            }

            if(action === 'close')
            {
                navigate('/SalesList');
            }
            else if(action === 'new'){
                setTableRow([]);
                setDetails('');
                setTransactionRef('');
                setCustomerInfo(null);
                setDeliveryDate('');
                setPayingAmount(0);
                setBills(0);
                setBankInfo('');
            }
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: 'Failed to submit payment data.',
                icon: 'error',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const submitNewCustomerForm = async () => {
        const formData = $("#add_customer_form").serialize();
        try {
          const response = await fetch(`${config.api_url}/ws-add-customer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              authorization: `Bearer ebu`,
          },
          body: formData,
      });

          const result = await response.json();
          if (result.success) {
            Swal.fire({
              title: "Success!",
              text: "Customer added successfully.",
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
          });

            setShowModal(false);
            getRequiresCustomerList();

        }
    } catch (error) {
      console.error("Error accepting order:", error);
  }
};

return (
    <div>
    <Header />
    <div className="breadcrumbs">
    <div className="container-fluid">
    <div className="row">
    <div className="col-12 col-lg-12 col-sm-12">
    <a href="#"><i className="fa fa-home"></i></a> &gt;
    <a href="/Dashboard">Dashboard</a> &gt;
    <span className="last-crumb">Receive Payment Edit</span>
    </div>
    </div>
    </div>
    </div>
    <ViewCustomer />
    <div className="main-container">
    <form id='new_sales_order' >
    <div className="container-fluid">
    <div className="row">
    <div className="col-12 col-lg-12 col-sm-12">
    <div className="show-order-area dashboard">
{/* Add Customer Modal */}
<button type="button" onClick={() => setShowModal(true)} className='create-catalogue-btn'>Add Customer</button>
<AddCustomerModal
show={showModal}
onHide={handleCloseModal}
onSubmit={submitNewCustomerForm}
/>
<div style={{ marginBottom: '20px', float: 'left' , width: '100%' }}>
<div className="newsalesorderform">
<div style={{ float: "right", width: "100%" }}>
</div>
<hr />
<div className="row mb-3 padd-l-13px">
<div className="col-6 col-lg-6 col-sm-6">
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="customer" className="col-form-label">Select Customer <span className='red'>*</span> </label>
</div>
<div className="col-8 col-lg-9 col-sm-9">
 <Select
  name="customer_id"
  options={options}
  onChange={handleCustomerChange}
  placeholder="Select Customer"
  isSearchable
  value={options.find(option => option.value === tableRow?.[0]?.customer_id) || null} // Safe navigation using optional chaining
 isDisabled={true} 

 />

</div>
</div>
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="delivery_date" className="col-form-label">Date <span className='red'>*</span></label>
</div>
<div className="col-8 col-lg-3 col-sm-3">
<CustomDateInput name="delivery_date" id="delivery_date" onChange={handleDateChange} value={deliveryDate} className="form-control" />
</div>
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="bank" className="col-form-label">Bank <span className='red'>*</span> </label>
</div>
<div className="col-8 col-lg-3 col-sm-3">
<BankSuggestionBox
    bank_id={bankInfo?.value ?? initialBankId ?? null}
    onBankChange={handleBankChange}
/>
</div>
</div>
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="details" className="col-form-label">Details </label>
</div>
<div className="col-8 col-lg-9 col-sm-9">
<input type="text" className="form-control" name="details"  onChange={handleDetailsChange} value={details} />
</div>
</div>
</div>
<div className="col-6 col-lg-6 col-sm-6">
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="transaction_ref" className="col-form-label">Transaction Ref </label>
</div>
<div className="col-8 col-lg-9 col-sm-9">
<input type="text" className="form-control" name="transaction_ref"  onChange={handleTransactionChange} value={transactionRef} />
</div>
</div>
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="paying_amount" className="col-form-label">Paying Amount</label>
</div>
<div className="col-8 col-lg-9 col-sm-9">
<input type="text" className="form-control" disabled value={payingAmount} name="paying_amount" />
</div>
</div>
<div className="row mb-3">
<div className="col-4 col-lg-3 col-sm-3">
<label htmlFor="balance" className="col-form-label">Balance</label>
</div>
<div className="col-8 col-lg-9 col-sm-9">
<input type="text" className="form-control" disabled value={bills-payingAmount} name="balance" />
</div>
</div>
</div>
</div>
</div>

<div className="verical-scrl-wrapper common-table receivepayment-table" id="style-3">

<table className="table table-bordered dataTable" id="neworderTable1">
<thead>
<tr>
<th>Select</th>
<th>Job Ref</th>
<th>S.O. No</th>
<th>Raised On</th>
<th>Type</th>
<th>Customer (ID)</th>
<th>Value</th>
<th>Balance</th>
<th>Pay</th>
{/* <th>Due Date</th> */}
</tr>
</thead>
<tbody>
{tableRow.length > 0 ? (
    tableRow.map((row, index) => (
    <tr key={index}>

    <td>
    <label className="checkbox">
    <input
    type="checkbox"
    checked={checkedRows.includes(index)}
    onChange={() => handleCheckboxChange(index)}
    />
    <span className="default"></span>
    </label>
    </td>
    <td>{row.job_ref}</td>
    <td>{row.sales_id}</td>
    <td>{row.date}</td>
    <td>{row.type}</td>
    <td>
    <a
    className="viewbtn"
    href="#"
    data-id={row.customer_id}
    data-bs-toggle="modal"
    data-bs-target="#view_customer"
    title="View Customer"
    >
    {row.company_name} ({row.customer_id})
    </a>
    </td>
    <td>{row.value}</td>
    <td>{Math.round((getMaxPayForRow(row) - (parseFloat(row.pay) || 0)) * 100) / 100}</td>
    <td>
    <input
    type="text"
    name="pay[]"
    className="form-control qtyinputbox"
    value={row.pay === '' || row.pay === null || row.pay === undefined ? '' : row.pay}
    style={{ textAlign: 'right' }}
    onChange={(e) => handlePayChange(index, e.target.value)}
    placeholder="Enter Amount"
    inputMode="decimal"
    />
    </td>
    {/* <td>{row.due_date}</td> */}
    </tr>
    ))
    ) : (
    <tr>
    <td colSpan="9" className="text-center">
    No data available.
    </td>
    </tr>
    )}
    </tbody>
    </table>

    </div>
    <hr />
    <a href="#" className="common-closebtn">Cancel</a> &nbsp;
    <div className="btn-group bouble-btn" role="group" aria-label="Basic example">
    <button onClick={(e)=>handleSubmit(e, 'close')} type="button" className="saveclose" disabled={isSubmitting}>Save & Close</button>
    <button onClick={(e)=>handleSubmit(e, 'new')} type="button" className="savenew" disabled={isSubmitting}>Save & New</button>
    </div>
    </div>
    </div>
    </div>
    </div>
    </div>
    </form>
    </div>
    <Footer />
    </div>
    );
};

export default ReceivePaymentEdit;
